import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { PageNotFoundComponent } from './shared/page-not-found/page-not-found.component';
import { PageErrorComponent } from './shared/page-error/page-error.component';
import { ResourceConstant } from './shared/constants/resource-constant';
import { PageBadDataComponent } from './shared/page-bad-data/page-bad-data.component';
import { PageNotAuthorizedComponent } from './shared/page-not-authorized/page-not-authorized.component';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { VrskAuthOktaLogoutComponent } from '@uw-verisk/auth-okta';
import { SupportAuthGuard } from './core/support.guard';

const routes: Routes = [
  {
    path: 'auth/logout',
    component: VrskAuthOktaLogoutComponent
  },
  {
    path: 'auth/callback',
    component: OktaCallbackComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'dashboard',
  },
  {
    // Old name
    path: 'FDC/dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    // New name
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
    data: {permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    // Old name
    path: 'FDC/site',
    loadChildren: () => import('./pages/site.module').then(m => m.SiteModule),
    data: { permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'pinpoint-support',
    loadChildren: () => import('./pages/support/support.module').then(m => m.SupportModule),
    data: { permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard, SupportAuthGuard]
  },
  {
    // New name
    path: 'builder',
    loadChildren: () => import('./pages/site.module').then(m => m.SiteModule),
    data: { permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    // Old name
    path: 'FDC/details',
    loadChildren: () => import('./pages/details/details.module').then(m => m.DetailsModule),
    data: { permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    // New name
    path: 'settings',
    loadChildren: () => import('./pages/details/details.module').then(m => m.DetailsModule),
    data: { permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'question-template',
    loadChildren: () => import('./pages/question-template/question-template.module').then(m => m.QuestionTemplateModule),
    data: {permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'question-library',
    loadChildren: () => import('./pages/question-library-page/question-library.module').then(m => m.QuestionLibraryModule),
    data: {permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'upload-questions',
    loadChildren: () => import('./pages/upload-questions/upload-questions.module').then(m => m.uploadQuestionsModule),
    data: {permission: ResourceConstant.loadPermission },
    canActivate: [OktaAuthGuard]
  },
  {
    path: 'FDC/page-bad-data',
    pathMatch: 'full',
    component: PageBadDataComponent
  },
  {
    path: 'FDC/error',
    pathMatch: 'full',
    component: PageErrorComponent
  },
  {
    path: 'FDC/page-not-found',
    pathMatch: 'full',
    component: PageNotFoundComponent
  },
  {
    path: 'FDC/page-not-authorized',
    pathMatch: 'full',
    component: PageNotAuthorizedComponent
  },
  { path: '**', pathMatch: 'full', component: PageNotFoundComponent }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule],
  providers: [PreloadAllModules]
})
export class AppRoutingModule { }
